module.exports = __webpack_public_path__ + "static/media/cupcake-dessert-food-svgrepo-com.7de2209c.svg";